export default {
  title: 'Calculadora de ingresos por tarifa de servicio',
  description: 'Estima lo que genera la tarifa de servicio cada mes. Las cifras se actualizan mientras escribes.',
  authoritative:
    'El porcentaje y la tarifa máxima a continuación son la configuración que se aplicará. El valor promedio del pedido y el GMV mensual son solo estimaciones.',
  off_notice:
    'La tarifa de servicio está desactivada en este restaurante, por lo que aún no genera ingresos. Guarda una tarifa arriba para activarla.',
  fields: {
    recommended: 'Recomendado: {{value}}',
    aov: {
      label: 'Valor promedio del pedido',
      help: 'Tamaño típico de pedido en tu sistema de pedidos en línea.',
      placeholder: 'p. ej. 32,50',
    },
    percentage: {
      label: 'Porcentaje de tarifa de servicio',
      help: 'Entre {{min}}% y {{max}}%.',
    },
    max_amount: {
      label: 'Tarifa máxima por pedido',
      help: '{{max}} es el máximo de la plataforma.',
      below_min: 'La tarifa máxima debe ser de al menos {{min}}.',
    },
    monthly_gmv: {
      label: 'GMV mensual',
      help: 'Valor total de pedidos procesados por mes.',
      placeholder: 'p. ej. 85000',
    },
  },
  outputs: {
    partner_revenue: 'Tu ingreso mensual estimado',
    approximate: 'Cifra aproximada basada en los valores anteriores; el ingreso real variará.',
    estimate_inputs: 'Basado en tu valor de pedido y GMV estimados; el ingreso real variará.',
    share: 'Esta es tu participación del {{share}}% del total de la tarifa de servicio recaudada.',
    total_collected: 'Total de tarifa de servicio recaudada de los clientes al pagar',
    total_collected_note: '— pagado por los clientes, no es ingreso adicional sobre la cifra anterior.',
    effective_rate: 'Tasa de tarifa efectiva en todos los pedidos',
  },
};
